module.exports = __webpack_public_path__ + "static/media/bq.60ba4677.svg";